import type { SingleSpaPluginConfig, WidgetConfigFields } from "./types";

function parseJsonIfString<T>(raw: unknown): T | undefined {
  if (raw == null) return undefined;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw) as T;
    } catch {
      return undefined;
    }
  }
  return raw as T;
}

export function parseSpaPluginConfig(raw: unknown): SingleSpaPluginConfig {
  const obj = parseJsonIfString<Record<string, unknown>>(raw) ?? {};
  return obj as unknown as SingleSpaPluginConfig;
}

export function parseWidgetConfig(raw: unknown): WidgetConfigFields | undefined {
  if (raw == null) return undefined;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw) as WidgetConfigFields;
    } catch {
      return undefined;
    }
  }
  if (typeof raw === "object") {
    return raw as WidgetConfigFields;
  }
  return undefined;
}
